import { safeRedirect } from "@jkast90/kast-common/auth";
import { FAMILY_APP_RETURNS } from "@jkast90/kast-common/family";

/**
 * Where this site sends the user after signing in or confirming: a family
 * site over https, loopback, or a native app's sign-in return
 * (`waypoint://auth`, `kdgames://auth`), else kast-dev.net.
 */
export function loginRedirect(value: string | null | undefined): string {
  return safeRedirect(value, { appReturns: FAMILY_APP_RETURNS });
}
